import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetUserEmployersDistribution = {
  getUserEmployersDistribution: { data: null, loading: false, error: null },
};

export const getUserEmployersDistribution = createAsyncThunk('user/getUserEmployersDistribution', async (userId, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/users/${userId}/employers/distribution`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response?.data || res.response);
    });
});

export const reducerGetUserEmployersDistribution = {
  [getUserEmployersDistribution.pending]: (state) => {
    state.getUserEmployersDistribution.loading = true;
    state.getUserEmployersDistribution.data = null;
    state.getUserEmployersDistribution.error = null;
  },
  [getUserEmployersDistribution.fulfilled]: (state, action) => {
    state.getUserEmployersDistribution.loading = false;
    state.getUserEmployersDistribution.data = action.payload;
    state.getUserEmployersDistribution.error = null;
  },
  [getUserEmployersDistribution.rejected]: (state, action) => {
    state.getUserEmployersDistribution.loading = false;
    state.getUserEmployersDistribution.data = null;
    state.getUserEmployersDistribution.error = action.payload;
  },
};
